import { IconsProps } from '@/types/shared'
import React from 'react'

const KPIIcons: React.FC<IconsProps> = (props) => {
    return (
        <div {...props}>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-gem-icon lucide-gem"
            >
                <path d="M10.5 3 8 9l4 13 4-13-2.5-6" />
                <path d="M17 3a2 2 0 0 1 1.6.8l3 4a2 2 0 0 1 .013 2.382l-7.99 10.986a2 2 0 0 1-3.247 0l-7.99-10.986A2 2 0 0 1 2.4 7.8l2.998-3.997A2 2 0 0 1 7 3z" />
                <path d="M2 9h20" />
            </svg>
        </div>
    )
}

export default KPIIcons
